import type { ToolDefinition } from '../domain/tools/types';
import { ToolWorkspace } from '../features/workspace/ToolWorkspace';

export function ToolRoutePage({ tool }: { readonly tool: ToolDefinition }) {
  return <ToolWorkspace tool={tool} />;
}
